import React, { FC } from 'react'
import clsx from 'clsx'

export interface FormInputLabelProps {
    inputId: string
    label: string
    size?: 'lg' | 'md' | 'sm'
    forSelect?: boolean
}   

export const FormInputLabel: FC<FormInputLabelProps> = ({
    inputId,
    label,
    size = 'md',
    forSelect,
}) => {

    return forSelect ? (<>
        <div id={`${inputId}-label`} className={clsx(
            `block text-${size}`,
            'relative h-0 bg-base-100',
            size === 'lg' && 'top-0 left-2 px-1',
            size === 'md' && 'top-0 left-1.5 px-1',
            size === 'sm' && 'top-0 left-1.5 px-1',
        )}>
            <div className='opacity-0'>
                { label }
            </div>
        </div>
        <label htmlFor={inputId} style={{ zIndex: 12 }} className={clsx(
            `block text-${size} text-slate-600 dark:text-gray-300 relative text-opacity-85`,
            // The label floats over the select control; without this, it
            // intercepts clicks on the top of the control and the menu never
            // opens. It is decorative (the control opens on its own click).
            'pointer-events-none',
            size === 'lg' && 'top-1 left-3',
            size === 'md' && 'top-0.5 left-2.5',
            size === 'sm' && 'top-0.5 left-2.5',
        )}>
            <span className='bg-base-100 rounded px-0.5 dark:px-1 py-0.5'>{ label }</span>
        </label>
    </>) : (<>
        <div style={{ zIndex: 11 }} id={`${inputId}-label`} className={clsx(
            `block text-${size}`,
            'relative h-0 bg-base-100',
            size === 'lg' && 'top-3 left-2 px-1',
            size === 'md' && 'top-3 left-1.5 px-1',
            size === 'sm' && 'top-1.5 left-1.5 px-1',
        )}>
            <div className='opacity-0'>
                { label }
            </div>
        </div>
        <label htmlFor={inputId} style={{ zIndex: 12 }} className={clsx(
            `block text-${size} text-slate-600/85 dark:text-gray-300 relative`,
            size === 'lg' && 'top-3 left-3',
            size === 'md' && 'top-2.5 left-2.5',
            size === 'sm' && 'top-2 left-2.5',
        )} id={inputId}>
            <span className='bg-base-100 rounded px-0.5 dark:px-1 py-0.5'>{ label }</span>
        </label>
    </>)
}
